
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { License } from '@/types/catalogs/Licenses'
import moment from 'moment'
import CatalogsService from '@/services/CatalogsService'

@Component({
  name: 'ReleaseLicensesModal'
})
export default class ReleaseLicensesModal extends Vue {
  @Prop({ required: true })
  licenses: License[]

  @Prop({ required: false, default: false })
  fromAdminLicensesList: boolean

  deleteLicensesConfirm: boolean = false

  /**
   * Calls the DELETE function for every license on the list
   * that receives as parameter, and display a toast for each promise resolved
   *
   * @param licenses to release (delete)
   */
  async deleteLicenses (licenses: License[]) {
    let licensesReleased: Promise<License>[] = []
    licenses.forEach(license => {
      let request = CatalogsService.deleteLicense(license.id)
      licensesReleased.push(request)
      request
        .then((response) => {
          let licenseResponse = `La licencia: ${license.id} - usuario: ${license.user.name} - dispositivo: ${license.device.name}`
          this.$bvToast.toast(`${licenseResponse} ha sido liberada`, {
            title: 'Liberación exitosa',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            solid: true,
            autoHideDelay: 5000
          })
        })
        .catch((error) => {
          // Manage current and future error format
          let dataError = error.response.data
          let errors = []
          if (dataError.errors) {
            dataError.errors.forEach((e: any) => {
              errors.push(e.description)
            })
          } else {
            errors.push(dataError.description ? dataError.description : error.response)
          }
          let licenseResponse = `La licencia: ${license.id} - usuario: ${license.user.name} - dispositivo: ${license.device.name}`
          this.$bvToast.toast(`${licenseResponse} no se ha podido liberar. ${errors.join(', ')}`, {
            title: 'Error en la liberación',
            variant: 'danger',
            toaster: 'b-toaster-top-left',
            solid: true,
            autoHideDelay: 5000
          })
        })
    })
    await Promise.allSettled(licensesReleased)
      .finally(() => {
        if (this.fromAdminLicensesList) {
          this.$emit('update-licenses-list', true)
        } else {
          this.$emit('update-licenses-list', false)
        }
      })
    this.closeDeleteLicensesModal()
  }

  /**
   * Hides modal for delete licenses
   * and turn off the confirmation flag
   */
  closeDeleteLicensesModal () {
    this.deleteLicensesConfirm = false
    this.$bvModal.hide('delete-licenses-modal')
  }

  /**
   * Generates the iso date format
   *
   * @param date to format
   * @returns ISO 8601 format date
   */
  dateFormat (date?: Date) {
    return date ? moment(date).format('DD/MM/YYYY').toString() : '- -/- -/- - - -'
  }
}
